import React, { useContext, useEffect, useMemo, useState } from 'react'
import { observer } from 'mobx-react-lite'
import D3LinkHorizontal from '../../D3Components/D3LinkHorizontal'
import { IOrgStageCoordsGetterOutput } from '../functions/getOrgStages-1'
import { getIDs, getPrevStageID } from '../functions/getID'
import { constants } from '../../../Constants'
import RootStoreContext from '../../../storage/RootStore'
import { interStageData } from '../data/matrix-data'

interface LinesProps extends IOrgStageCoordsGetterOutput { }

export const Lines: React.FC<LinesProps> = observer(({
    orgStagesCoords, connectionDotsCoords, arrayStages
}) => {

    const { CONNECTING_LINE } = constants


    type Item = { x: number, y: number, node: boolean }

    const interStageLines: { from: Item, to: Item }[][] = useMemo(() => {

        let output: { from: Item, to: Item }[][] = []

        if (orgStagesCoords) {
            interStageData.map(listOrgStageID => {

                let b: { from: Item, to: Item }[] = []

                for (let i = 0; i < listOrgStageID.length - 1; i++) {
                    let startID = listOrgStageID[i];
                    let endID = listOrgStageID[i + 1]

                    let startCoords = orgStagesCoords[startID]
                    let endCoords = orgStagesCoords[endID];

                    if (startCoords && endCoords) {
                        b.push({ from: startCoords, to: endCoords })
                    }
                }

                output.push(b)
            })

            output.push(
                [{ from: {x: 170, y:50, node: true}, to: {x: 280, y: 140, node: true} }],
                [{ from: {x: 280, y:140, node: true}, to: {x: 350, y: 103, node: true} }],
                [{ from: {x: 350, y:102, node: true}, to: {x: 505, y: 560, node: true} }],
                // [{ from: {x: 355, y:102, node: true}, to: {x: 505, y: 560, node: true} }],
                
                /// Від встановлення факту смерті до збору статистики                
                [{ from: {x: 170, y:50, node: true}, to: {x: 340, y: 560, node: true} }],
                [{ from: {x: 340, y:560, node: true}, to: {x: 550, y: 560, node: true} }],
                // [{ from: {x: 340, y:420, node: true}, to: {x: 550, y: 560, node: true} }],




                [{ from: {x: 550, y:560, node: true}, to: {x: 870, y: 560, node: true} }],
                
                /// Міжетапна точка проміжної реєстрації - державна реєстрація
                [{ from: {x: 455, y:145, node: true}, to: {x: 625, y: 177, node: true} }],

                // [{ from: {x: 430, y:400, node: true}, to: {x: 500, y: 560, node: true} }],

                
                )
        }
        return output
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])









    return (<>
        {/* Lines - out */}
        {orgStagesCoords && Object.keys(orgStagesCoords).map((orgStageID, i) => {
            let { orgID, stageID, stageIndex } = getIDs(orgStageID)

            if (orgStagesCoords.hasOwnProperty(orgStageID)
                && orgStagesCoords[orgStageID].node
                && connectionDotsCoords.hasOwnProperty(stageID)) {
                // out coordinates of org-stage dot
                let { x: xOut, y: yOut } = orgStagesCoords[orgStageID]
                // in coordinates of connecting dot
                let { x: xIn, y: yIn } = connectionDotsCoords[stageID]

                /// Skip last stage
                if (stageID === 'stage_8') {
                    return null
                }

                // skipping for specific ids
                if (
                    (stageID === 'stage_7' && orgID !== 'org_20')
                ) {
                    return false
                }



                return (
                    <D3LinkHorizontal key={`out-${orgStageID}`}
                        from={[xOut, yOut]}
                        to={[xIn, yIn]}
                        strokeColor={CONNECTING_LINE.COLOR}
                        strokeWidth={CONNECTING_LINE.WIDTH}
                        strokeOpacity={CONNECTING_LINE.OPACITY}
                    />
                )
            }
        })}


        {/* Lines - in */}
        {orgStagesCoords && Object.keys(orgStagesCoords).map((orgStageID, i) => {
            let { orgID, stageID, stageIndex } = getIDs(orgStageID)

            let prevStageID = getPrevStageID(stageID)

            if (orgStagesCoords.hasOwnProperty(orgStageID)
                && orgStagesCoords[orgStageID].node
                && connectionDotsCoords.hasOwnProperty(prevStageID)) {
                // out coordinates of org-stage dot
                let { x: xOut, y: yOut } = orgStagesCoords[orgStageID]
                // in coordinates of previous connecting dot
                let { x: xIn, y: yIn } = connectionDotsCoords[prevStageID]

                // if (stageIndex <= 1 || stageIndex > arrayStages.length - 1) return null


                // skipping for specific ids
                if (
                    (stageID === 'stage_8' && orgID === 'org_22')
                    || 
                    (stageID === 'stage_5' && orgID === 'org_27')
                    ||
                    (stageID === 'stage_2' && orgID === 'org_6')
                    ||  /// лінія до суду 
                    (stageID === 'stage_4' && orgID === 'org_10')
                ) {
                    return false
                }

                return (
                    <D3LinkHorizontal key={`out-${orgStageID}`}
                        from={[xOut, yOut]}
                        to={[xIn, yIn]}
                        strokeColor={CONNECTING_LINE.COLOR}
                        strokeWidth={CONNECTING_LINE.WIDTH}
                        strokeOpacity={CONNECTING_LINE.OPACITY}
                    />
                )
            }
        })}




        {/* Lines between stages */}
        {interStageLines.length && interStageLines.map((line, i) => {
            return line.map((dot, k) => {
                let { from, to } = dot
                return (
                    <D3LinkHorizontal key={`out-betweeen`}
                        from={[from['x'], from['y']]}
                        to={[to['x'], to['y']]}
                        strokeColor={CONNECTING_LINE.COLOR}
                        // strokeColor={'limegreen'}
                        strokeWidth={CONNECTING_LINE.WIDTH}
                        strokeOpacity={CONNECTING_LINE.OPACITY}
                    />
                )
            })
        })}




    </>)
})
